<template>

    <div>

        <h2 class="mb-2">Fält för kontaktuppgifter</h2>
        <div class="custom-info pt-0 slide-block" style="font-style: normal;" :class="{ 'show' : showHelp}">Här väljer du vilka fält som de anställda på varje företag behöver fylla i, eller
            som du eller kunden fyller i för att registrera anställda i systemet. Det finns tre typer av fält:<br>
            <ul>
                <li><b>Låsta fält</b> - dessa fält finns alltid och är alltid obligatoriska för alla anställda. Detta fält kan
                    importas automatiskt under Anställda.
                </li>
                <li><b>Fördefinierade fält</b> - detta är fält som fnns förinställda som du kan välja att aktivera. Dessa fält
                    kommer att valideras korrekt om kunden registrerar sig (t ex kräva rätt struktur för en
                    e-postadress). Detta fält kan importas automatiskt under Anställda.
                </li>
                <li><b>Egna fält</b> - dessa fält kan du lägga till själv, helt individuellt per kund. Det är alltid vanliga
                    textfält som inte valideras. Detta fält går inte att importera.
                </li>
            </ul>
        </div>
        <a href="#" @click.prevent="showHelp = !showHelp" style="font-weight: 600;">Så fungerar det</a>

        <h3 class="mt-6">Valda fält</h3>
        <div class="new-list-group mb-10">

            <div class="new-list-group-item new-list-group-header no-decoration">

                <div class="row">
                    <div class="col-2"><span>Ordning</span></div>
                    <div class="col-2"><span>Välj</span></div>
                    <div class="col-4"><span>Typ</span></div>
                    <div class="col-6"><span>Fält</span></div>
                    <div class="col-5"><span>Obligatoriskt</span></div>
                </div>

            </div>

            <div class="new-list-group-item" :key="field.id" v-for="(field, index) in activeFields">
                <div class="row">
                    <div class="col-2" style="font-size: 18px;">
                        <span class="fa fa-arrow-down"
                              style="margin-right: 4px;"
                              v-if="index !== (activeFields.length - 1)"
                              @click="reOrder(field, activeFields[index+1], 'down')"
                        ></span>
                        <span class="fa fa-arrow-up"
                              v-if="index !== 0"
                              @click="reOrder(field, activeFields[index-1], 'up')"
                        ></span>
                    </div>
                    <div class="col-2">
                        <div class="form-check" :title="field.group === 'Låst fält' ? 'Kan ej ändras' : ''">
                            <input class="form-check-input" type="checkbox" :checked="field.is_active" :disabled="field.group === 'Låst fält'" v-model="field.is_active">
                        </div>
                    </div>
                    <div class="col-4"><span>{{ field.group }}</span></div>
                    <div class="col-6">
                        <span v-if="field.group !== 'Eget fält'">
                            <b>{{ field.label }}</b>
                        </span>
                        <div class="w-75" v-if="field.group === 'Eget fält'">
                            <input type="text" class="form-control" value="Mitt egna fält" v-model="field.label">
                        </div>
                    </div>
                    <div class="col-6">
                        <div class="form-check" :title="field.group === 'Låst fält' ? 'Kan ej ändras' : ''">
                            <input class="form-check-input" type="checkbox" :checked="field.is_required" :disabled="field.group === 'Låst fält'" v-model="field.is_required">
                        </div>
                    </div>
                </div>
            </div>

            <h3 class="mt-6">Lägg till fält</h3>
            <div class="new-list-group-item" :key="field.id" v-for="(field, index) in idleFields">
                <div class="row">
                    <div class="col-2" style="font-size: 18px;"></div>
                    <div class="col-2">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="field.is_active">
                        </div>
                    </div>
                    <div class="col-4"><span>{{ field.group }}</span></div>
                    <div class="col-6"><span><b>{{ field.label }}</b></span></div>
                    <div class="col-8">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="field.is_required" disabled>
                        </div>
                    </div>
                </div>
            </div>

            <div class="new-list-group-item new-list-group-item-add">
                <div class="row">
                    <div class="col-2"></div>
                    <div class="col-2">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" checked disabled>
                        </div>
                    </div>
                    <div class="col-4">Eget fält</div>
                    <div class="col-6">
                        <div class="w-75"><input type="text" class="form-control" v-model="new_text_field.label"></div>
                    </div>
                    <div class="col-4">
                        <div class="form-check">
                            <input class="form-check-input" type="checkbox" v-model="new_text_field.is_required">
                        </div>
                    </div>
                    <div class="col-6 d-flex justify-content-end">
                        <button class="btn btn-primary btn-sm" @click="addNewTextField()">Lägg till</button>
                    </div>
                </div>
            </div>

        </div>

        <div class="d-flex justify-content-end">
            <button class="btn btn-primary" :disabled="patcher.submitted" @click="patcherPatch()">
                <span class="spinner-border spinner-border-sm"></span>
                Spara
            </button>
        </div>

    </div>

</template>

<script>

import uniqid from 'uniqid'

import patcher from '../../../../shared/mixins/patcher'

export default {

    mixins: [
        patcher
    ],

    props: {
        company: {
            required: true
        }
    },

    data () {
        return {
            dynamic_fields: this.company.dynamic_fields,

            new_text_field: {},

            showHelp:false
        }
    },

    created () {
        this.resetNewField()
    },

    watch: {
        company: {
            deep: true,
            handler () {
                this.dynamic_fields = this.company.dynamic_fields
            }
        }
    },

    computed: {
        patcherUrl () {
            return '/companies/' + this.company.id + '/dynamicFields'
        },
        patcherData () {
            return { dynamic_fields: this.dynamic_fields }
        },
        activeFields () {
            return this.dynamic_fields.filter(f => f.is_active).sort((a, b) => a.order - b.order)
        },
        idleFields () {
            return this.dynamic_fields.filter(f => !f.is_active)
        }
    },

    methods: {
        reOrder (field, fieldToSwap, direction) {
            if (direction === 'down') {
                field.order++
                fieldToSwap.order--
            }
            if (direction === 'up') {
                field.order--
                fieldToSwap.order++
            }
        },

        addNewTextField () {
            this.dynamic_fields.push({
                id: uniqid(),
                type: 'text',
                is_new: true,
                label: this.new_text_field.label,
                is_required: this.new_text_field.is_required,
                is_active: 1,
                group: 'Eget fält',
                order: this.activeFields.length
            })

            this.resetNewField()
        },

        resetNewField () {
            this.new_text_field = {
                label: '',
                is_required: false
            }
        },

        patcherSuccess (data) {
            this.$emit('refresh')
            bus.$emit(
                'notify',
                'Formulärsfälten har sparats'
            )
        }
    }

}
</script>
